/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'mustache',
  'pip-model',
  'plugin.tooltip',
  'pip-events',
  'window',
  'breakpoints',
  'pip-common.utils',
  'javascript-debounce',
  'pip-analytics__buy-one-get-one'
],
  function buyOneGetOneFree(
    $,
    Mustache,
    pip,
    tooltip,
    pipEvents,
    window,
    breakpoints,
    pipCommonUtils,
    debounce,
    bogoAnalytics
  ) {

    var constants = {
      fulfillmentMethods: {
        shipToHome: 'ShipToHome'
      },
      fulfillmentLocations: {
        directShip: 'DirectShip'
      },
      maxMsbReqCountPerCall: 25
    };
    var helperMethods = {
      isEligible: function buyOneGetOneIsEligible() {
        return pip.features.buyOneGetOneFreeEnabled
          && pip.features.multiSkuBulkPromotionEnabled
          && pip.products.primary.data.info.isBogoAnchorItem
          && pip.products.primary.data.promotions
          && Array.isArray(pip.products.primary.data.info.bogoFreeItems)
          && pip.products.primary.data.info.bogoFreeItems.length;
      },
      handleError: function buyOneGetOneHandleError(err) {
        if (pip.debugMode) {
          /* eslint-disable-next-line no-console */
          console.log('ERROR: pip-buy_one_get_one', err);
        }

        if (typeof window.newrelic === 'object' && window.newrelic.noticeError && window.newrelic.addPageAction) {
          window.newrelic.addPageAction('JSError', {
            'errorSourceFile': 'pip-buy_one_get_one',
            'errorType': err.name,
            'errorMessage': err.message,
            'errorStack': err.stack
          });
          window.newrelic.noticeError(err);
        }
      },
      calculateRatingPercentage: function buyOneGetOneCalRatingPercentage(rating, numberOfStars) {
        var rate = rating || null;
        var scale = numberOfStars || 5;
        if ((!rate || isNaN(rate) || rate < 0)) {
          return 0.00;
        }
        return ((rate / scale) * 100).toFixed(2)
      },
      isScrolledIntoView: function buyOneGetOneIsScrolledIntoView(container, intersectingElement) {
        return $(intersectingElement).offset().top <= $(container).height() + $(container).offset().top;
      },
      setListenerForLazyLoadingPods: function buyOneGetOneSetListenerForLazyLoadingPods(listContainer, listItem, callback) {
        $(listContainer).scroll(
          debounce(
            function excuteCallBackIfTargetElementIsScrolledIntoView() {
              var isInView = helperMethods.isScrolledIntoView(listContainer, listItem);
              if (isInView) {
                $(listContainer).off('scroll');
                callback && callback();
              }
            }, 100));
      },
      isScrollbarVisible: function BuyOneGetOneIsScrollbarVisible(element) {
        return $(element).prop('scrollHeight') > $(element).prop('clientHeight');
      },
      getMultiSkuBulkProducts: function BuyOneGetOneGetMultiSkuBulkProducts(listOfFreeOmsIds) {
        return $.ajax({
          url: ('/p/svcs/getMSBProducts/' + (listOfFreeOmsIds.join())),
          error: function (xhr, status, error) {
            helperMethods.handleError(error)
          }
        })
      },
      checkFreeItemEligibility: function BuyOneGetOneCheckFreeItemEligibility(fulfillmentOption) {
        if (!(fulfillmentOption && fulfillmentOption.fulfillment && (Number(fulfillmentOption.expectedQuantityAvailable) > 0))) {
          return false;
        }
        return fulfillmentOption.fulfillment === constants.fulfillmentMethods.shipToHome;
      }
    };

    var view = {
      templates: {
        title: $('#buy-one-get-one-title-template').html(),
        list: $('#buy-one-get-one-list-template').html(),
        listLazy: $('#buy-one-get-one-list-lazy-template').html(),
        listItem: $('#buy-one-get-one-list-item-template').html(),
        products: $('#buy-one-get-one-products-template').html(),
        preview: $('#buy-one-get-one-preview-template').html(),
        tooltip: $('#buy-one-get-one-tooltip-template').html()
      },

      classes: {
        listPodSelected: 'buy-one-get-one-list__pod--selected',
        globalStyleHide: 'u--hide',
        dataFetchTarget: 'bogo--data-fetch-target'
      },

      selectors: {
        buyOneGetOne: '#buy-one-get-one',
        title: '#buy-one-get-one-title',
        tooltip: '#buy-one-get-one-tooltip',
        products: '#buy-one-get-one-products',
        list: '#buy-one-get-one-list',
        listPod: '.buy-one-get-one-list__pod',
        preview: '#buy-one-get-one-preview',
        buybelt: '#buybelt-wrapper',
        newBuybelt: '#buybelt-wrapper-new',
        listContainer: '.buy-one-get-one-list-contents',
        dataFetchTarget: '.bogo--data-fetch-target'
      },

      init: function buyOneGetOneInitView() {
        if (viewModel.allEligibleFreeItems.length) {
          view.updateDOM.buyOneGetOne();
          view.initEventListeners();
          $(view.selectors.buyOneGetOne).removeClass(view.classes.globalStyleHide);
        }
      },

      render: {
        title: function buyOneGetOneRenderTitle() {
          return Mustache.render(view.templates.title, viewModel, {
            tooltip: view.templates.tooltip
          });
        },
        products: function buyOneGetOneRenderProducts() {
          return Mustache.render(view.templates.products, viewModel, {
            list: view.templates.list,
            listItem: view.templates.listItem
          });
        },
        preview: function buyOneGetOneRenderPreview() {
          return Mustache.render(view.templates.preview, viewModel);
        },
        tooltip: function buyOneGetOneRenderTooltip() {
          return Mustache.render(view.templates.tooltip, viewModel);
        }
      },

      updateDOM: {
        buyOneGetOne: function buyOneGetOneUpdateDom() {
          $(view.selectors.title).html(view.render.title());
          view.updateDOM.products();
          $(view.selectors.buyOneGetOne).removeClass(view.classes.globalStyleHide);
        },
        products: function buyOneGetOneUpdateDomProducts() {
          $(view.selectors.products).html(view.render.products());
        },
        preview: function buyOneGetOneUpdateDomPreview() {
          $(view.selectors.preview).html(view.render.preview());
        },
        tooltip: function buyOneGetOneUpdateDomTooltip() {
          var tooltipOptions = {
            type: 'click',
            position: 'bottom',
            content: view.render.tooltip(),
            width: breakpoints.isActiveBreakpointEqualToOrSmallerThan('Small') ? 'medium' : 'large',
            closeButton: true,
            bestPosition: true,
            closeOnClick: true
          };
          $(view.selectors.tooltip).tooltip(tooltipOptions);
          $('a.tip-Opener').off('.buyOneGetOne');
          $('a.tip-Opener').on('click.buyOneGetOne', function() {
            $(view.selectors.tooltip).tooltip('hide')
          });
        },
        updatePodListContainer: function buyOneGetOneUpdatePodListContainer() {
          $(view.selectors.listContainer).append(Mustache.render(view.templates.listLazy, viewModel, {
            listItem: view.templates.listItem
          }));
        }
      },

      setPodListeners: function buyOneGetOneInitPodListeners() {
        $(view.selectors.listPod).each(function buyOneGetOneAddPodListener() {
          var listPod = $(this);
          listPod.on('click', function buyOneGetOneListPodCallback() {
            view.setSelectedProduct(listPod);
            view.setSelectionStyle(listPod);
          });
        });
      },

      initTooltipListener: function buyOneGetOneInitTooltipListener() {
        view.updateDOM.tooltip();
      },

      initEventListeners: function buyOneGetOneInitEventListeners() {
        view.initTooltipListener();
        view.setPodListeners();
        view.setUpListenerForLazyLoadingAdditionalPods();
      },
      modifyItemForView: function buyOneGetOneModifyItemForView(item) {
        item.ratingInPercentage =
          item.itemRating &&
          item.itemRating.averageRating &&
          helperMethods.calculateRatingPercentage(item.itemRating.averageRating, 5);

        if (item.price && item.price.formattedOriginalPrice) {
          var formattedPrice = item.price.formattedOriginalPrice.split('$')[1];
          item.originalDollars = formattedPrice.split('.')[0] ? formattedPrice.split('.')[0] : 0;
          item.originalCents = formattedPrice.split('.')[1] ? formattedPrice.split('.')[1] : 0;
        }

        if (item.price && item.price.formattedSpecialPrice) {
          var formattedSpecialPrice = item.price.formattedSpecialPrice.split('$')[1];
          item.specialDollars = formattedSpecialPrice.split('.')[0] > 0 ? formattedSpecialPrice.split('.')[0] : null;
          item.specialCents = formattedSpecialPrice.split('.')[1] > 0 ? formattedSpecialPrice.split('.')[1] : '00';
        }

        if (item.price && typeof item.price.dollarOff === 'number') {
          item.price.dollarOff = item.price.dollarOff.toFixed(2);
        }

        return item;
      },

      setSelectedProduct: function buyOneGetOneSetSelectedProduct(target) {
        viewModel.allEligibleFreeItems.forEach(function bogoSetSelectedProduct(item) {
          if (item.itemId === target[0].dataset.omsid) {
            viewModel.selectedProduct = view.modifyItemForView(item);
            viewModel.setBogoSelectedItem(item);
            view.updateDOM.preview();
            $(view.selectors.buybelt).attr('data-shared-section', 'bogo');
            $(view.selectors.newBuybelt).attr('data-shared-section', 'bogo');
          }
        });
      },
      setSelectionStyle: function buyOneGetOneSetSelectionStyle(target) {
        $(view.selectors.listPod).each(function clearBogoSelectionStyle() {
          $(this).removeClass(view.classes.listPodSelected);
        });
        target.addClass(view.classes.listPodSelected);
      },
      setUpListenerForLazyLoadingAdditionalPods: function buyOneGetOneSetUpListenerForLazyLoadingAdditionalPods() {
        var podList = $(view.selectors.listPod);
        var podListLength = podList.length;
        var index = podListLength >= 5 ? podListLength - 5 : 0;

        podList.eq(index).addClass(view.classes.dataFetchTarget);

        if (helperMethods.isScrollbarVisible(view.selectors.listContainer)) {
          helperMethods.setListenerForLazyLoadingPods(
            view.selectors.listContainer,
            view.selectors.dataFetchTarget,
            viewModel.lazyLoadData
          );
        } else {
          viewModel.lazyLoadData();
        }
      },
      resetEventListeners: function buyOneGetOneResetEventListeners() {
        $(view.selectors.dataFetchTarget).removeClass(view.classes.dataFetchTarget);
        view.setUpListenerForLazyLoadingAdditionalPods();
      }
    };

    var viewModel = {
      allEligibleFreeItems: [],
      eligibleFreeItemsBuffer: [],
      selectedProduct: null,
      isProductSelected: false,
      longDescription: '',
      yetToBeLoadedList: null,
      init: function buyOneGetOneInitViewModel(data) {
        if (data && Array.isArray(data.multiSkuBulkProducts)) {
          viewModel.setEligibleFreeItems(data.multiSkuBulkProducts);
          viewModel.listSize = viewModel.allEligibleFreeItems.length < 5
            ? '-' + viewModel.allEligibleFreeItems.length
            : '-many';
          viewModel.setPromotionLongDescription();
        }
      },

      setEligibleFreeItems: function buyOneGetOneSetEligibleFreeItems(bogoFreeItemsData) {
        viewModel.eligibleFreeItemsBuffer = [];
        bogoFreeItemsData.forEach(function (freeItem) {
          var fulfillmentOptions = freeItem.fulfillments ? freeItem.fulfillments : freeItem.fulfillment;
          if (Array.isArray(fulfillmentOptions)) {
            fulfillmentOptions.forEach(function (option) {
              if (helperMethods.checkFreeItemEligibility(option)) {
                viewModel.allEligibleFreeItems.push(freeItem);
                viewModel.eligibleFreeItemsBuffer.push(freeItem);
              }
            });
          }
        });
      },
      setPromotionLongDescription: function buyOneGetOneSetPromotionLongDescription() {
        if (pipCommonUtils.deepGet(pip, 'products.primary.data.promotions.promotionList.0.promoLongDescription')) {
          viewModel.longDescription = pip.products.primary.data.promotions.promotionList[0].promoLongDescription;
        }
      },
      setBogoSelectedItem: function buyOneGetOneSetBogoSelectedItem(item) {
        if (pipCommonUtils.deepGet(pip, 'products.primary.data.info')) {
          var itemDetails = {
            itemId: item.itemId,
            quantity: 1,
            fulfillmentMethod: constants.fulfillmentMethods.shipToHome,
            fulfillmentLocation: constants.fulfillmentLocations.directShip
          };
          pip.products.primary.data.info.bogoSelectedItem = { itemDetails: itemDetails };
        }
      },
      lazyLoadData: function buyOneGetOneLazyLoadData() {
        model
          .getAdditionalFreeItems()
          .then(
            function (response) {
              try {
                if (response) {
                  viewModel.setEligibleFreeItems(response.multiSkuBulkProducts);
                  view.updateDOM.updatePodListContainer();
                  view.setPodListeners();
                  viewModel.eligibleFreeItemsBuffer = [];
                  if (viewModel.yetToBeLoadedList && viewModel.yetToBeLoadedList.length) {
                    view.resetEventListeners();
                  }
                }
              } catch (error) {
                helperMethods.handleError(error);
              }
            });
      },
      resetViewModelData: function buyOneGetOneResetViewModelData() {
        viewModel.allEligibleFreeItems = [];
        viewModel.eligibleFreeItemsBuffer = [];
        viewModel.listSize = 0;
        viewModel.selectedProduct = null;
        viewModel.isProductSelected = false;
        viewModel.longDescription = '';
        viewModel.yetToBeLoadedList = null;
        if (pipCommonUtils.deepGet(pip, 'products.primary.data.info')) {
          pip.products.primary.data.info.bogoSelectedItem = null;
        }
      }
    };

    var model = {
      init: function buyOneGetOneInitModel() {
        var listOfFreeOmsIds = pip.products.primary.data.info.bogoFreeItems.slice();
        viewModel.yetToBeLoadedList = listOfFreeOmsIds.splice(constants.maxMsbReqCountPerCall);
        return helperMethods.getMultiSkuBulkProducts(listOfFreeOmsIds);
      },
      getAdditionalFreeItems: function buyOneGetOneGetAdditionalFreeItems() {
        if (viewModel.yetToBeLoadedList && viewModel.yetToBeLoadedList.length) {
          var payLoad = viewModel.yetToBeLoadedList.splice(0, constants.maxMsbReqCountPerCall);
          return helperMethods.getMultiSkuBulkProducts(payLoad);
        }
        return $.Deferred().resolve(false);
      }
    };

    return {
      init: function buyOneGetOneInit() {
        try {
          if (helperMethods.isEligible()) {
            viewModel.resetViewModelData();
            model.init()
              .then(function (bogoFreeItemsData) {
                try {
                  viewModel.init(bogoFreeItemsData);
                  if (viewModel.allEligibleFreeItems.length) {
                    view.init();
                    bogoAnalytics.init();
                    pipEvents.buyOneGetOne.buyOneGetOneAnalytics.trigger();
                  }
                } catch (error) {
                  helperMethods.handleError(error);
                }

              });
          }
        } catch (error) {
          helperMethods.handleError(error);
        }
      },
      view: view,
      viewModel: viewModel,
      model: model
    }
  });

}.call(window));